import controller from './list.controller';
import template from './list.html';

function RouteConfig($stateProvider) {
	'ngInject';

	$stateProvider
		.state('app.private.sales.list', {
			controller,
			template,
			'url': '/list',
			'controllerAs': 'vm',
			'params': {
				'params': {},
				'page': 0
			}
		});
}

export default RouteConfig;



/** WEBPACK FOOTER **
 ** ./client/private/sales/list/list.route.js
 **/